/**
 *    @author:
 *    @since:
 *
 */

import { Component, OnInit, ViewEncapsulation, ViewChild, ElementRef} from '@angular/core';
import { Router } from '@angular/router'; 
import { TimerService } from 'src/refresh/service/timer-service';
import { FormBaseComponent } from '../_common/component/form-base.component';
import { InputData, ParentInfo } from '../_common/data/input-data';
import { Path } from  "../_common/constant/page-const";
import { AboutTheChildScreen2Validation } from './about_the_child_screen_2.validator';
import { ItemList } from '../_common/constant/item-list';
import { BirthPlace } from 'src/refresh/service/constant';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import { ProgressService } from 'src/refresh/service/progress-service';

@Component({ 
      selector: 'about_the_child_screen_2',
      templateUrl: './about_the_child_screen_2.component.html',
      styleUrls: ['./about_the_child_screen_2.component.less']
})
export class AboutTheChildScreen2Component extends FormBaseComponent implements OnInit {

      public parents:ParentInfo[];
      public childNameParam: Object;
      ///public isLastNameAgreed:boolean;
      public isUnableToCertify:boolean;
      ///public isCustodyOtherThanParent:boolean;
      public certyfyingCount:number;
      public parentCount:number;
      public childName: string = "";
      public childDOB: string = "";
      public childGender: string = ""; 
      public childGenderSample: string = "";
      public childWeight: string = "";
      public childBirthOrder: string ="";
      public childCityTown : string = "";
      public placeOfBirth : string = "";
      public nameOfBPlace : string = "";
      public attendantType: string = "";
      public attendantName: string = "";
      public municipality: string = "";
      public locale: string;

      @ViewChild('canvas', { static: true })
      canvas: ElementRef<HTMLCanvasElement>;
      private ctx: CanvasRenderingContext2D;

       constructor( protected router: Router ,
                    public timerService:TimerService,
                    //protected progress:ProgressService,
                    public data:InputData,
                    private items:ItemList,
                    private translateService: TranslateService ) {

                    super(router,timerService);  
                    super.setNextPage(Path.AboutTheParentsMain,Path.AboutTheChildMain);
                    super.setValidator(new AboutTheChildScreen2Validation(this));
                    this.setParentCount(data);
                    this.setParentAgree();
                    registerLocaleData(localeFr, 'fr');

                    //if(!this.isLastNameAgreed && !this.isCustodyOtherThanParent
                    //     && this.parentCount > 1){ this.setLastName()}

                    this.childNameParam = { childName: data.aboutChild.name.getFullName()  };
                    this.childName = data.aboutChild.name.getFullName();
                    this.childDOB = data.aboutChild.birthDay;

                    this.getGender();    
                    this.getWeight(); 
                    this.getBirthOrder(); 
                    this.getCityTown();  
                    this.getPlace();
                    this.getAttendant();
                    this.getMunicipality();

                    this.data.aboutChild.birthPlaceName = this.nameOfBPlace;

                    InputData.currentPageIdx = 9;
                    if ( InputData.moveNext == 0 || InputData.moveNext == InputData.currentPageIdx ) this.timerService.isForwarding = false;
       }

       private setParentCount(data:InputData) {
            this.parents = data.parents;
            this.isUnableToCertify = data.eligibility.isUnableToCertify=='Y';
            ///this.isCustodyOtherThanParent = data.eligibility.isCustodyOtherThanParent=='Y';
            if ( this.isUnableToCertify ) {
                  if(data.eligibility.listedParentCount > 2){
                     this.parentCount = data.eligibility.certifyingParentCount;
                     this.parents = this.parents.slice(0,this.parentCount);
                     } else {
                     this.parentCount = 1;
                  }
                } else {
                   this.parentCount = data.eligibility.listedParentCount;
              }
      }

      setParentAgree(){
            if (this.data.aboutChild.isParentAgreeOnLastName == 'N') {
                  ///this.isLastNameAgreed = false;
            } else if( this.data.aboutChild.isParentAgreeOnLastName == 'Y') {
                  ///this.isLastNameAgreed = true;
            } else {
                  ///this.isLastNameAgreed = true;
                  this.data.aboutChild.isParentAgreeOnLastName = 'Y';
            }

      }

      /**
       setLastName(){
            let lastName = "";
            let parentNames = new Array();
            for ( let i = 0; i < this.parents.length; i++ ){
                   parentNames.push(this.parents[i].name.last);  
                  }
            const distinctparentNames = parentNames.filter((value, index, self) => {
                  return self.indexOf(value) === index});

            distinctparentNames.sort();

             for ( let i = 0; i < distinctparentNames.length; i++ ){
                  lastName += distinctparentNames[i];
                  if(distinctparentNames[i + 1]){
                        lastName += "-";
                  }
             }      
            this.data.aboutChild.name.last = lastName;
      }
       */

       getGender() {
            this.childGender = this.data.aboutChild.gender;
            if(this.childGender === 'F') {
                  if(this.translateService.currentLang === 'fr'){
                        this.childGenderSample = "Féminin";
                  } else {
                        this.childGenderSample = "Female";
                  }
            }else if(this.childGender === 'M'){
                  if(this.translateService.currentLang === 'fr'){
                        this.childGenderSample = "Masculin";
                  } else {
                        this.childGenderSample = "Male";
                  }
            } else if(this.childGender === 'U'){
                  if(this.translateService.currentLang === 'fr'){
                        this.childGenderSample = "Non déterminé";
                  } else {
                        this.childGenderSample = "Undetermined";
                  }
            }
      }

       getWeight(){
            if(this.data.aboutChild.grams){
                  this.childWeight =  this.data.aboutChild.grams.toString() + ' ' + this.translateService.instant('shared.weight.grams');
              } else if (this.data.aboutChild.pounds || this.data.aboutChild.ounces){
                  this.childWeight = this.data.aboutChild.pounds.toString() + ' ' +
                  this.translateService.instant('shared.weight.lbs') + ' ' + 
                  this.data.aboutChild.ounces.toString() + ' ' +
                  this.translateService.instant('shared.weight.oz');;
              }
      }

      getBirthOrder(){
            if(this.data.eligibility.birthType != "1") {
                  this.childBirthOrder = 'shared.birthOrder.' + this.data.aboutChild.birthOrder;
            }
      }

      getCityTown(){
            if (this.data.aboutChild.cityTown != this.NotFound){
                  if(this.data.aboutChild.cityTown.startsWith('_')){
                        let city = this.items.cityList.get(this.data.aboutChild.cityTown);
                        this.childCityTown = city.match(/\(([^)]+)\)/)[1];
                  } else{
                        this.childCityTown = this.items.cityList.get(this.data.aboutChild.cityTown);
                  }
                } else if (this.data.aboutChild.otherCity) {
                  this.childCityTown = this.data.aboutChild.otherCity;
              }

              this.data.aboutChild.cityName = this.childCityTown;
      }

      getPlace(){

            let city = this.getCityCode();

            if(this.data.aboutChild.birthPlaceType === BirthPlace.Hospital){
                 this.placeOfBirth = 'shared.birthPlace.HO'; 
                 if(this.data.aboutChild.birthPlaceCode!= this.NotFound) {
                  let hospitalList = this.items.hospitalList[city];
                  if ( hospitalList ) {
                        this.nameOfBPlace = hospitalList.get(this.data.aboutChild.birthPlaceCode);
                  }
                 } else if(this.data.aboutChild.otherBirthPlace) {
                  this.nameOfBPlace = this.data.aboutChild.otherBirthPlace;
                 }
            } else if(this.data.aboutChild.birthPlaceType === BirthPlace.BirthCenter)  {
                 this.placeOfBirth = 'shared.birthPlace.BC';
                 if(this.data.aboutChild.birthPlaceCode!= this.NotFound) {
                  let birthCenterList = this.items.birthCenterList[city];
                  if ( birthCenterList ) {
                        this.nameOfBPlace = birthCenterList.get(this.data.aboutChild.birthPlaceCode);
                  }
                 } else if(this.data.aboutChild.otherBirthPlace) {
                  this.nameOfBPlace = this.data.aboutChild.otherBirthPlace;
                 }
            } else if(this.data.aboutChild.birthPlaceType === BirthPlace.Home) {
                 this.placeOfBirth = 'shared.birthPlace.HM';
                 if(this.data.aboutChild.birthStreetNumber) {
                 this.nameOfBPlace = this.data.aboutChild.birthStreetNumber + " " 
                 + this.data.aboutChild.birthStreetName;
            } else {
                  this.nameOfBPlace = this.data.aboutChild.birthStreetName;
                 }
            } else if(this.data.aboutChild.birthPlaceType === BirthPlace.Other) {
                 this.placeOfBirth = 'shared.birthPlace.OT'; 
                 if(this.data.aboutChild.birthStreetNumber) {
                 this.nameOfBPlace =  this.data.aboutChild.birthStreetNumber + " " 
                 + this.data.aboutChild.birthStreetName;
            } else {
                  this.nameOfBPlace = this.data.aboutChild.birthStreetName;
            }
            }

      }

      getAttendant() {
            if(this.data.aboutChild.attendentType==="P"){
                  this.attendantType = 'shared.attendant.P';
                  if(this.data.aboutChild.isDoctorSingleName != "Y"){
                      this.attendantName = this.data.aboutChild.attendentFirstName + 
                      " " + this.data.aboutChild.attendentLastName;  
                  } else {
                      this.attendantName = this.data.aboutChild.attendentSingleName;
                  }
            } else if(this.data.aboutChild.attendentType==="M"){
                  this.attendantType = 'shared.attendant.M';
                  if(this.data.aboutChild.isMidwifeSingleName != "Y"){
                        this.attendantName = this.data.aboutChild.attendentFirstName + 
                        " " + this.data.aboutChild.attendentLastName;  
                    } else {
                        this.attendantName = this.data.aboutChild.attendentSingleName;
                    }
            } else if(this.data.aboutChild.attendentType==="O"){
                  this.attendantType = 'shared.attendant.O';
                  if(this.data.aboutChild.isSomeoneElseSingleName != "Y"){
                        this.attendantName = this.data.aboutChild.attendentFirstName + 
                        " " + this.data.aboutChild.attendentLastName;  
                    } else {
                        this.attendantName = this.data.aboutChild.attendentSingleName;
                    }
            }

      }

      getMunicipality(){
            if (this.data.aboutChild.cityTown != this.NotFound){
                  let city = this.getCityCode();
                  this.municipality = this.items.regionList.get(city);
                  if( !this.municipality )  this.municipality = "";  
                  this.data.aboutChild.region = this.municipality;
            } else {
                  this.municipality = "";
                  this.data.aboutChild.region = "";
            }
      }

      getCityCode() {
                  let city = this.data.aboutChild.cityTown;
                  let  idx = city.lastIndexOf("_");
                  if ( idx > 0 ) city = city.substring(idx+1);
                  return city;
      }

       public ngOnInit() {

            if ( super.forwardNext(InputData.currentPageIdx) ) return;
            
            this.BRDraw();
            this.locale = this.translateService.currentLang;

            this.translateService.onLangChange
                  .subscribe((langChangeEvent: LangChangeEvent) => {
                  this.locale = langChangeEvent.lang;
            })

            if(this.data.eligibility.birthType == "1"){
                  document.getElementById("birthOrder").remove();
            }
       }

       public BRDraw() {
            this.ctx = this.canvas.nativeElement.getContext('2d');
                   this.ctx.fillStyle = "#000";  
                   this.ctx.font = "bold 10pt Helvetica";
                   if(this.data.aboutChild.name.single){
                        this.ctx.fillText(this.data.aboutChild.name.single.replace(/\s+/g,' ').trim(), 6, 28); 
                   } else {
                        this.ctx.fillText(this.data.aboutChild.name.last.replace(/\s+/g,' ').trim(), 6, 28);
                        this.fitText(this.data.aboutChild.name.first,328,this.ctx,10);
                        this.ctx.fillText(this.data.aboutChild.name.first.replace(/\s+/g,' ').trim(), 6, 60);
                        this.fitText(this.data.aboutChild.name.middle,314,this.ctx,10);
                        this.ctx.fillText(this.data.aboutChild.name.middle.replace(/\s+/g,' ').trim(), 336, 60);
                   }
                   
                   this.ctx.font = "bold 10pt Helvetica";
                   this.ctx.fillText(this.childGenderSample, 538, 28);
                   this.ctx.fillText(this.childDOB.replace(/-/g, '/'), 6, 92);
                   
                   this.ctx.fillText(this.childCityTown.replace(/\s+/g,' ').trim(), 6, 125);
                   if (this.municipality != null) {
                        this.ctx.fillText(this.municipality.toUpperCase(), 337, 125);
                   }
       
                   this.fitText(this.nameOfBPlace,412,this.ctx,10);
                   this.ctx.fillText(this.nameOfBPlace.replace(/\s+/g,' ').trim() , 240, 92);

          }

          fitText = function(text,MAX_SIZE,ctx,startFontSize) {
            var fontSize = startFontSize;
            
            while(true) {
                   ctx.font="bold "+fontSize+"pt Helvetica";
                   var  width = ctx.measureText(text).width;
                   
                   if ( width <= 	MAX_SIZE ) return;
                   
                   fontSize -= 0.2;
            }
          }
          
          public zoomin:boolean = false;
          zoomChange(){
               let zoom = document.getElementById("canvas");
               let zoomPic =document.getElementById("canvasPic");
               if(!this.zoomin){
                  zoom.classList.remove('canvas');
                  zoom.classList.add('canvasZoom');
                  zoomPic.classList.remove('canvasPic');
                  zoomPic.classList.add('canvasZoom');
                  this.zoomin = true;
                  } else {
                        zoom.classList.remove('canvasZoom');
                        zoom.classList.add('canvas');
                        zoomPic.classList.remove('canvasZoom');
                        zoomPic.classList.add('canvasPic');
                        this.zoomin = false;
                  }
          }
          
}
